import styled from "styled-components";
import { SettingButton } from "../../../../../../ui/SettingButton";

export const ExternalPaneButton = styled(SettingButton)`
  display: inline-flex;
  padding: 0 1em;
  height: 2.2em;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
`;
